import { getStoreValue } from '@core/utils/store';
import { DEFAULT_LANGUAGE } from '@core/constants/DEFAULT';
import { WESOG_STORE_PARAMS } from '@core/constants/STORE';

/** @type {Object} Spanish translates */
const esES = {
    results: {
        orderBy: {
            new: 'Más recientes',
            old: 'Más antiguas',
            downloads: 'Más descargados',
            views: 'Más vistos',
            sim: 'Más similares',
        },
    },
    searcher: {
        switch: {
            label: '%company IA',
            shortLabel: 'IA',
        },
    },
    lightbox: {
        subTitle: 'colecciones de %name',
        searcher: {
            placeholder: 'Buscar por nombre',
        },
    },
    filters: {
        editorial: {
            characters: {
                anonymous: 'Anónimo',
            },
        },
    },
    metaTags: {
        home: {
            title: 'Imágenes de Stock Editoriales y Creativas de Alta Calidad - %company Media',
            description:
                'Descubre imágenes de noticias exclusivas y fotos de stock creativas en %company Media. Fotografías actualizadas para medios, diseñadores y empresas. Encuentra contenido visual único para tus proyectos.',
            editorial: {
                title: 'Imágenes de Noticias de España y del Mundo de Alta Calidad - %company Media',
                description:
                    'Encuentra imágenes de noticias exclusivas en %company Media. Fotografías actualizadas para medios y publicaciones.',
            },
            creative: {
                title: 'Imágenes de Stock Creativas para Uso Comercial - %company Media',
                description:
                    'Fotos de stock creativas, ideales para diseñadores, empresas y medios. Encuentra imágenes únicas.',
            },
        },
        reportsList: {
            default: {
                title: 'Reportajes de Noticias y Contenido Creativo - %company Media',
                description:
                    'Explora nuestros reportajes de noticias y contenido creativo en %company Media. Encuentra las mejores colecciones de imágenes organizadas por categorías.',
            },
            video: {
                title: 'Videos de actualidad de alta calidad | %company',
                description:
                    'Accede a videos exclusivos de actualidad de noticias de famosos, espectáculos, moda y corazón. Perfectos para medios.',
            },
            mostViewed: {
                title: 'Última Hora: Noticias y Fotos de Actualidad en Tiempo Real | %company',
                description:
                    'Consulta las últimas noticias de actualidad en tiempo real con fotos exclusivas en %company. Cobertura inmediata de Corazón, Realeza, Moda, Política, Deportes y Espectáculos.',
            },
            famous: {
                title: 'Fotos de famosos y eventos más recientes | %company',
                description:
                    'Descubre las mejores fotos de famosos en eventos exclusivos. Accede a imágenes inéditas de la prensa rosa.',
            },
            royal: {
                title: 'Fotos de la realeza española e internacional | %company',
                description:
                    'Accede a fotos únicas de la realeza española en actos oficiales y eventos exclusivos. ¡Descarga ahora!',
            },
            performance: {
                title: 'Fotos de espectáculos, alfombras rojas y premios | %company',
                description:
                    'Encuentra fotos impactantes de alfombras rojas y premios. Celebra lo mejor de cine y espectáculos.',
            },
            politics: {
                title: 'Fotos de noticias políticas de España y del Mundo | %company',
                description:
                    'Accede a imágenes de políticos españoles en eventos clave. ¡Fotografías de alta calidad disponibles!',
            },
            sports: {
                title: 'Fotos de deportes y eventos deportivos de España y del Mundo | %company',
                description:
                    'Consulta las últimas noticias y fotos de deportes en %company. Cobertura de fútbol, baloncesto, tenis y las competiciones deportivas más importantes del mundo.',
            },
            fashion: {
                title: 'Fotos de desfiles de moda y pasarelas de España y del Mundo | %company',
                description:
                    'Explora las últimas tendencias con fotos de desfiles de moda en España. Imágenes exclusivas para tus artículos.',
            },
            society: {
                title: 'Fotos de acontecimientos sociales de España y del Mundo | %company',
                description:
                    'Fotos de acontecimientos sociales. Imágenes perfectas para medios de actualidad.',
            },
            nourishment: {
                title: 'Fotos de Alimentación: Imágenes de Comida y Recetas | %company',
                description:
                    'Encuentra las mejores imágenes de comida y recetas en %company. Fotos de alta calidad para proyectos creativos relacionados con la alimentación y la gastronomía.',
            },
            beauty: {
                title: 'Lifestyle: Imágenes de Estilo de Vida y Tendencias | %company',
                description:
                    'Explora fotos de estilo de vida, bienestar, moda y tendencias en %company. Encuentra imágenes de alta calidad para proyectos creativos relacionados con el lifestyle.',
            },
            decoration: {
                title: 'Fotos de Decoración: Inspiración Visual para Interiores y Exteriores | %company',
                description:
                    'Inspírate con las mejores fotos de decoración de interiores y exteriores en %company. Encuentra imágenes de calidad para proyectos relacionados con diseño de espacios.',
            },
            nature: {
                title: 'Naturaleza: Imágenes de Paisajes, Flora y Fauna | %company',
                description:
                    'Descubre impresionantes fotos de naturaleza, incluyendo paisajes, vida silvestre y flora en %company. Contenido visual para proyectos de conservación y naturaleza.',
            },
            travel: {
                title: 'Viajes: Imágenes de Destinos y Aventuras alrededor del Mundo | %company',
                description:
                    'Explora imágenes de destinos turísticos, aventuras y paisajes impresionantes en %company. Encuentra fotos de viajes para tus proyectos creativos.',
            },
        },
        cartList: {
            title: '%company - Cart List View',
            description: 'List of assets in your cart',
        },
        details: {
            title: '%company - Details View',
            description:
                'Discover the images of %company. Find the best high-quality images for your creative projects.',
        },
        downloadLightbox: {
            title: '%company - Download Lightbox',
            description: 'Download the lightbox of %company.',
        },
        downloadReport: {
            title: '%company - Download Report',
            description: 'Download the report of %company.',
        },
        lightbox: {
            title: '%company - Lightbox List View',
            description: 'Lightbox List View',
        },
        userProfile: {
            title: '%company - User Profile',
            description: 'User Profile',
        },
        reportDetails: {
            title: '%company - Report Details View',
            description:
                'Discover the report of %company. Find the best high-quality images for your creative projects.',
        },
        lightboxDetails: {
            title: '%company - Lightbox Details View',
            description:
                'Discover the lightbox of %company. Find the best high-quality images for your creative projects.',
        },
        searcherResults: {
            title: '%company - Searcher Results',
            description:
                'Find exclusive news images at %company Media. Updated photographs for media and publications.',
        },
    },
};

/** @type {Object} English translates */
const enEN = {
    results: {
        orderBy: {
            new: 'More recent',
            old: 'Oldest',
            downloads: 'More downloads',
            views: 'More views',
            sim: 'Similar',
        },
    },
    searcher: {
        switch: {
            label: '%company AI',
            shortLabel: 'AI',
        },
    },
    lightbox: {
        subTitle: "%name's collections",
        searcher: {
            placeholder: 'Search by name',
        },
    },
    filters: {
        editorial: {
            characters: {
                anonymous: 'Anonymous',
            },
        },
    },
    metaTags: {
        home: {
            title: 'High-Quality News Images from Spain and the World - %company Media',
            description:
                'Find exclusive news images at %company Media. Updated photographs for media and publications.',
            editorial: {
                title: 'High-Quality News Images from Spain and the World - %company Media',
                description:
                    'Find exclusive news images at %company Media. Updated photographs for media and publications.',
            },
            creative: {
                title: 'High-Quality Creative Stock Images for Commercial Use - %company Media',
                description:
                    'Creative stock photos, ideal for designers, companies and media. Find unique images.',
            },
        },
        reportsList: {
            default: {
                title: 'News Reports and Creative Content - %company Media',
                description:
                    'Explore our news reports and creative content at %company Media. Find the best image collections organized by categories.',
            },
            video: {
                title: 'High-quality current affairs videos | %company',
                description:
                    'Access exclusive current affairs videos of celebrity news, shows, fashion and entertainment. Perfect for media.',
            },
            mostViewed: {
                title: 'Latest News: Real-time Current Affairs Photos | %company',
                description:
                    'Check the latest current affairs news in real time with exclusive photos at %company. Immediate coverage of Entertainment, Royalty, Fashion, Politics, Sports and Shows.',
            },
            famous: {
                title: 'Latest celebrity photos and events | %company',
                description:
                    'Discover the best celebrity photos at exclusive events. Access unpublished entertainment press images.',
            },
            royal: {
                title: 'Spanish and international royalty photos | %company',
                description:
                    'Access unique photos of Spanish royalty at official events and exclusive occasions. Download now!',
            },
            performance: {
                title: 'Show photos, red carpets and awards | %company',
                description:
                    'Find stunning photos of red carpets and awards. Celebrate the best of cinema and entertainment.',
            },
            politics: {
                title: 'Political news photos from Spain and the World | %company',
                description:
                    'Access images of Spanish politicians at key events. High-quality photographs available!',
            },
            sports: {
                title: 'Sports photos and sporting events from Spain and the World | %company',
                description:
                    "Check the latest sports news and photos at %company. Coverage of football, basketball, tennis and the world's most important sporting competitions.",
            },
            fashion: {
                title: 'Fashion show photos and runways from Spain and the World | %company',
                description:
                    'Explore the latest trends with fashion show photos in Spain. Exclusive images for your articles.',
            },
            society: {
                title: 'Social events photos from Spain and the World | %company',
                description:
                    'Social events photos. Perfect images for current affairs media.',
            },
            nourishment: {
                title: 'Food Photos: Images of Meals and Recipes | %company',
                description:
                    'Find the best food and recipe images at %company. High-quality photos for creative projects related to food and gastronomy.',
            },
            beauty: {
                title: 'Lifestyle: Images of Life Style and Trends | %company',
                description:
                    'Explore lifestyle photos, wellness, fashion and trends at %company. Find high-quality images for creative projects related to lifestyle.',
            },
            decoration: {
                title: 'Decoration Photos: Visual Inspiration for Interiors and Exteriors | %company',
                description:
                    'Get inspired with the best interior and exterior decoration photos at %company. Find quality images for projects related to space design.',
            },
            nature: {
                title: 'Nature: Images of Landscapes, Flora and Fauna | %company',
                description:
                    'Discover stunning nature photos, including landscapes, wildlife and flora at %company. Visual content for conservation and nature projects.',
            },
            travel: {
                title: 'Travel: Images of Destinations and Adventures around the World | %company',
                description:
                    'Explore images of tourist destinations, adventures and stunning landscapes at %company. Find travel photos for your creative projects.',
            },
        },
        cartList: {
            title: '%company - Cart List View',
            description: 'List of assets in your cart',
        },
        details: {
            title: '%company - Details View',
            description:
                'Discover the images of %company. Find the best high-quality images for your creative projects.',
        },
        downloadLightbox: {
            title: '%company - Download Lightbox',
            description: 'Download the lightbox of %company.',
        },
        downloadReport: {
            title: '%company - Download Report',
            description: 'Download the report of %company.',
        },
        lightbox: {
            title: '%company - Lightbox List View',
            description: 'Lightbox List View',
        },
        userProfile: {
            title: '%company - User Profile',
            description: 'User Profile',
        },
        reportDetails: {
            title: '%company - Report Details View',
            description:
                'Discover the report of %company. Find the best high-quality images for your creative projects.',
        },
        lightboxDetails: {
            title: '%company - Lightbox Details View',
            description:
                'Discover the lightbox of %company. Find the best high-quality images for your creative projects.',
        },
        searcherResults: {
            title: '%company - Searcher Results',
            description:
                'Find exclusive news images at %company Media. Updated photographs for media and publications.',
        },
    },
};

/**
 * Get the i18n translation.
 * @param {string} key - The key to translate.
 * @returns {string} The translated string.
 */
export const i18nKey = (key) => {
    if (getStoreValue(WESOG_STORE_PARAMS.CURRENT_LANGUAGE) === DEFAULT_LANGUAGE) {
        return esES[key] || key;
    }

    return enEN[key] || key;
};

/**
 * Get the translations.
 * @returns {Object} The translations.
 */
export const getTranslations = () => {
    if (getStoreValue(WESOG_STORE_PARAMS.CURRENT_LANGUAGE) === DEFAULT_LANGUAGE) {
        return esES;
    }

    return enEN;
};
